export default __webpack_public_path__ + "static/media/elo.b0b73d1e.svg";